exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome[data-v-53b884d3]{height:80vh;display:flex;align-items:center;justify-content:center;flex-direction:column}@keyframes pulse-data-v-53b884d3{0%{transform:scale(1)}50%{transform:scale(1.2)}to{transform:scale(1)}}.fa-cart-plus[data-v-53b884d3]{font-size:200%;cursor:pointer;animation:pulse-data-v-53b884d3 1s infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-53b884d3","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Start.vue
// module id = 121
// module chunks = 0